import { CountReportEntity } from '../entities';
import { authResource } from './Auth';
export const AccountReportDecryptionCountResource = authResource({
    path: '/accounts/:accountId/reports/decryptions/count/:countId?',
    schema: CountReportEntity
}).extend('get', {
    process: (response) => ({ count: response })
});
